export default __webpack_public_path__ + "static/media/package-tracker.ffa18617.png";